import React from "react";
import { Messages } from "../../../../../types/messages";
import { ArrowLeft, Mail, MessageSquare, ArrowRight } from "lucide-react";
import { Notification } from "../../../../../types/bookings";

type MessageRowType = {
  message: Messages;
  notifications?: Notification[];
  onClick: (message: Messages) => void;
};

const MessageRow = ({ message, notifications, onClick }: MessageRowType) => {
  const sent = message.action == "sent";
  const received = message.action == "received";
  const eMail = message.type == "email";
  const sms = message.type == "sms";
  const unread =
    (notifications?.filter((n) => n.id === message._id) ?? []).length > 0;

  const noteAddedDate = new Date(message.created_date);
  const addedDate = noteAddedDate.toLocaleString(window.locale, {
    dateStyle: "short"
  });
  const addedTime = noteAddedDate
    .toLocaleTimeString(window.locale, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    })
    .toUpperCase();
  return (
    <button
      type="button"
      className="MessageRow w-full flex mb-0.5 bg-[var(--grid-background)] first:rounded-t-toggle"
      onClick={() => onClick(message)}
    >
      <div className="MessageRow-Content w-full pt-panel-padding pr-panel-padding pb-panel-padding pl-0">
        <div className="MessageRow-Heading flex items-center">
          <div
            className={`MessageRow-Icon my-auto mx-[calc(var(--panelPadding)*2)] h-6 ${message.type}`}
          >
            {eMail && <Mail className="size-5" />}
            {sms && <MessageSquare className="size-5" />}
          </div>
          <div className="MessageRow-Title font-bold">
            {message.from ?? message.from_name}
          </div>
          <div className="MessageRow-Time ml-auto pr-panel-padding">
            {addedTime}
          </div>
          <div className="MessageRow-Date font-bold">{addedDate}</div>
        </div>
        <div className="MessageRow-Body pt-panel-padding flex items-center">
          <div
            className={`MessageRow-Icon my-auto mx-[calc(var(--panelPadding)*2)] h-6 ${message.action}`}
          >
            {sent && <ArrowLeft className="size-5" />}
            {received && <ArrowRight className="size-5" />}
          </div>
          <div
            className={`MessageRow-Message overflow-hidden whitespace-nowrap text-ellipsis max-w-full w-0 flex-grow ${unread ? "Unread font-bold" : ""}`}
          >
            {message.subject ?? message.body}
          </div>
        </div>
      </div>
    </button>
  );
};

export default React.memo<MessageRowType>(MessageRow);
